/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2026
 */

import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalRef } from 'ngx-bootstrap/modal';

/**
 * Dashboard card: Disclosure & Feedback Loop.
 *
 * Steve 2026-06-11 ask: removed the Counterintuitive Insights card from
 * the dashboard and replaced it with this one. (Counterintuitive was then
 * pulled from the printable report too on 2026-08-15, so it no longer
 * renders anywhere.) Pulls the per-archetype disclosure_prompts from the v1.0
 * content library — same data the printable report's Section 10 renders.
 */
const DISCLOSURE_AUDIENCES: { key: string; label: string; vulnerability: string }[] = [
  { key: 'spouse_partner', label: 'Spouse / Partner', vulnerability: 'High Vulnerability' },
  { key: 'close_friend', label: 'Close Friend', vulnerability: 'Medium / High Vulnerability' },
  { key: 'colleague_peer', label: 'Colleague / Peer', vulnerability: 'Medium Vulnerability' },
  { key: 'supervisor_mentor', label: 'Supervisor / Mentor', vulnerability: 'Medium / Low Vulnerability' },
  { key: 'direct_report_team_member', label: 'Direct Report / Team Member', vulnerability: 'Lower (Empowering)' },
];

@Component({
  selector: 'app-disclosure-feedback-loop-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './disclosure-feedback-loop-modal.component.html',
})
export class DisclosureFeedbackLoopModalComponent {
  @Input() primaryContent: any;

  audiences = DISCLOSURE_AUDIENCES;

  constructor(public bsModalRef: BsModalRef) {}

  promptFor(key: string): string {
    return (this.primaryContent?.disclosure_prompts || {})[key] || '';
  }

  get hasAnyPrompts(): boolean {
    return this.audiences.some(a => !!this.promptFor(a.key));
  }

  close(): void {
    this.bsModalRef.hide();
  }
}
